import React, { createContext, useState, useEffect } from 'react';
import { api } from '../services/api';

export const AuthCtx = createContext({
  token  : null,
  setToken: () => {},
  logout : () => {}
});

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('clientToken'));

  /* persiste / limpia localStorage */
  useEffect(() => {
    if (token) localStorage.setItem('clientToken', token);
    else       localStorage.removeItem('clientToken');
  }, [token]);

  const logout = async () => {
      try {
       await api.post('/clientes/logout');        // avisa al backend
      } catch (err) {
        console.error(err);                        // no rompas si falla
      } finally {
        setToken(null);                            // limpia el estado SIEMPRE
      }
    };

  return (
    <AuthCtx.Provider value={{ token, setToken, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}